import React from 'react';
import { List, ListItem, ListType, Icon, IconNames, Text } from '@dotcom/crown-ui';
import { NoPhotosUploadedProps } from '../photo-drawer-types';
import styles from '../photo-drawer.module.scss';

export const NoPhotosUploaded = ({
  labels,
  onDrawerImageUpload,
  inputFileRef,
}: NoPhotosUploadedProps): React.ReactElement => {
  const handleUploadDrawerImages = () => {
    onDrawerImageUpload && onDrawerImageUpload();
  };

  return (
    <button
      data-testid={`photo-upload-button`}
      className={styles['no-photos-uploaded-container']}
      onClick={() => {
        inputFileRef.current?.click();
        handleUploadDrawerImages();
      }}
    >
      <Icon className={styles['photo-lot-icon']} name={IconNames.PhotoslotBold} size={'40'} />
      <Text as="span" weight="bold" color="textPrimary">
        {labels.title}
      </Text>
      <List listStyle={ListType.Bullets} className={styles['no-photos-uploaded-list']}>
        {labels.steps.map((step, index) => (
          <ListItem className={styles['no-photos-uploaded-step']} key={index}>
            <Text as="span" color="textSecondary">
              {step}
            </Text>
          </ListItem>
        ))}
      </List>
    </button>
  );
};
